export const constructionsForInput = [
  {
    id: 1,
    name: "材料搬入",
  },
  {
    id: 2,
    name: "埋設工事",
  },

  {
    id: 3,
    name: "受架台組立工事",
  },
  {
    id: 4,
    name: "新規入場者教育",
  },
  {
    id: 5,
    name: "新規組立工事",
  },
  {
    id: 6,
    name: "保温残工事",
  },
  {
    id: 7,
    name: "酸洗残工事",
  },
  {
    id: 8,
    name: "追加工事",
  },
  {
    id: 9,
    name: "苦情処理工事",
  },
  {
    id: 10,
    name: "補修工事",
  },
];
export const constructions = [
  {
    id: 0,
    name: "全部",
  },
  {
    id: 1,
    name: "材料搬入",
  },
  {
    id: 2,
    name: "埋設工事",
  },
  {
    id: 3,
    name: "受架台組立工事",
  },
  {
    id: 4,
    name: "新規入場者教育",
  },
  {
    id: 5,
    name: "新規組立工事",
  },
  {
    id: 6,
    name: "保温残工事",
  },
  {
    id: 7,
    name: "酸洗残工事",
  },
  {
    id: 8,
    name: "追加工事",
  },
  {
    id: 9,
    name: "苦情処理工事",
  },
  {
    id: 10,
    name: "補修工事",
  },
];
